import Vue from "vue";
import Dinero from "dinero.js";
import moment from 'moment';

Vue.filter("formatMoney", amount => {
  return Dinero({ amount }).toFormat("$0,0.00");
});

const _formatDate = (date, format = 'MMM. Do, YYYY') => {
  let d = moment(date);

  if (!d.isValid())
    d = moment(date.toDate())

  return d.format(format);
}

Vue.filter('formatDate', (date, format = 'MMM. Do, YYYY') => {
  return _formatDate(date, format);
});

Vue.filter('formatFirestoreDate', (date, format = 'MMM. Do, YYYY') => {
  const d = date.toDate();
  return _formatDate(d, format);
});

Vue.filter('formatLocation', location => {
  return `${location.city}, ${location.state}, ${location.country}`;
})

Vue.filter('listSkills', skills => {
  let str = '';

  skills.forEach(skill => {
    if (str === '')
      str = `${skill.name}`
    else
      str += `, ${skill.name}`
  });

  return str;
})

Vue.filter('pluralize', (count, word) => {
  return count > 1 || count == 0 ? `${count} ${word}s` : `${count} ${word}`;
});

Vue.filter('stripHTML', (str) => {
 return str.replace(/<\/?[^>]+(>|$)/g, "")
});

Vue.filter('strlen', (str) => {
  return str.length;
});